// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"6a1f8c6a","41":"e5fb3eae","70":"274798c5","124":"67917f8d","145":"b59092c9","241":"b31896cb","319":"67917f8d","478":"57a6edbb","874":"67917f8d","918":"67917f8d","945":"3e9eb982"}[chunkId] + ".chunk.css";
};